// import { useState } from "react";

// export default function NewsletterPopup({ isOpen, onClose }) {
//   const [status, setStatus] = useState(null); // "success" | "error" | "loading" | null

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus("loading");

//     const form = e.target;
//     const email = form.elements["fields[email]"].value;

//     try {
//       const res = await fetch(
//         "https://t47cvh74j3yhodxla2o25y2wyq0zhgor.lambda-url.ap-southeast-1.on.aws/",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ email }),
//         }
//       );

//       if (res.ok) {
//         setStatus("success");
//         form.reset();
//       } else {
//         setStatus("error");
//       }
//     } catch (err) {
//       setStatus("error");
//     }
//   };

//   return (
//     <div
//       className={`fixed top-0 right-0 h-full w-80 bg-gray-900 text-white shadow-lg
//    transform transition-all duration-500 ease-in-out z-50
//    ${isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}`}
//     >
//       {/* Close button */}
//       <button
//         onClick={onClose}
//         className="absolute top-3 right-3 text-gray-400 hover:text-white text-lg"
//       >
//         ✕
//       </button>

//       <div className="p-6 mt-10">
//         <h2 className="text-lg font-bold mb-2">📬 Stay Updated</h2>
//         <p className="text-sm text-gray-300 mb-4">
//           Subscribe to get the latest updates!
//         </p>

//         <form onSubmit={handleSubmit} className="flex flex-col gap-3">
//           <input
//             type="email"
//             name="fields[email]"
//             placeholder="Enter your email"
//             required
//             className="border px-3 py-2 rounded text-black"
//           />
//           <button
//             type="submit"
//             disabled={status === "loading"}
//             className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
//           >
//             {status === "loading" ? "Subscribing..." : "Subscribe"}
//           </button>
//         </form>

//         {status === "success" && (
//           <p className="text-green-400 text-sm mt-3">
//             🎉 You’re in! We just sent you the latest updates.
//           </p>
//         )}
//         {status === "error" && (
//           <p className="text-red-400 text-sm mt-3">
//             ❌ Something went wrong. Please try again.
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
import { X, Mail } from "lucide-react";

export default function NewsletterPopup({ isOpen, onClose }) {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    const form = e.target;
    const email = form.elements["fields[email]"].value;

    try {
      const res = await fetch(
        "https://20vll3ttje.execute-api.ap-southeast-1.amazonaws.com/subscribe",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      if (res.ok) {
        setStatus("success");
        form.reset();
      } else if (res.status === 409) {
        setStatus("duplicate");
      }
      else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    // <div
    //   className={`fixed inset-0 flex items-end justify-end p-4 md:p-6 z-50
    //     bg-black/30 transition-all duration-500 ease-[cubic-bezier(0.22,0.61,0.36,1)]
    //     ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    // >
    //   <div
    //     className={`w-96 h-[50vh] bg-[#1e1e1e] text-white shadow-2xl p-6 relative rounded-xl
    //       transform transition-all duration-500 ease-in-out
    //       ${isOpen ? "translate-x-0" : "translate-x-full"}`}
    //   >
    //     {/* Close button */}
    //     <button
    //       onClick={onClose}
    //       className="absolute top-4 right-4 text-gray-400 hover:text-white"
    //     >
    //       <X size={22} />
    //     </button>

    //     {/* Header */}
    //     <div className="flex items-center gap-2 mb-6 mt-8">
    //       <Mail className="text-blue-400" />
    //       <h2 className="text-xl font-bold">
    //         Subscribe to Updates 
    //         (Personal Email) 
    //         </h2>
    //     </div>

    //     {/* Form */}
    //     <form onSubmit={handleSubmit} className="flex flex-col gap-3">
    //       <input
    //         type="email"
    //         name="fields[email]"
    //         placeholder="Enter your email"
    //         required
    //         className="border border-gray-600 bg-[#2c2c2c] px-3 py-2 rounded text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
    //       />
    //       <button
    //         type="submit"
    //         disabled={status === "loading"}
    //         className="bg-blue-600 text-white px-4 py-2 rounded-md font-medium
    //           hover:bg-blue-500 disabled:opacity-50 transition-all duration-150 ease-[cubic-bezier(0.22,0.61,0.36,1)]"
    //       >
    //         {status === "loading" ? "Subscribing..." : "Subscribe"}
    //       </button>
    //     </form>

    //     {/* Status messages */}
    //     {status === "success" && (
    //       <p className="text-green-400 text-sm mt-3">
    //         🎉 You’re in! We just sent you the latest updates.
    //       </p>
    //     )}

    //     {/* duplicate email message */}
    //     {status === "duplicate" && (
    //       <p className="text-yellow-400 text-sm mt-3">
    //         ⚠️ This email is already subscribed.
    //       </p>
    //     )}
    //     {status === "error" && (
    //       <p className="text-red-400 text-sm mt-3">
    //         ❌ Something went wrong. Please try again.
    //       </p>
    //     )}
    //   </div>
    // </div>

    <div
      className={`fixed inset-0 flex items-center justify-center p-4 md:p-6 z-50
        bg-black/30 transition-all duration-500 ease-[cubic-bezier(0.22,0.61,0.36,1)]
        ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      <div
        className={`w-96 h-[50vh] bg-[#1e1e1e] text-white shadow-2xl p-6 relative rounded-xl
          transform transition-all duration-500 ease-in-out
          ${isOpen ? "translate-x-0" : "translate-x-full"}
          md:w-96 md:h-[50vh] md:top-0 md:left-0 md:right-0 md:bottom-0 md:transform-none
          sm:w-[90%] sm:h-auto sm:max-h-[80vh] sm:top-1/2 sm:left-1/2 sm:translate-x-[-50%] sm:translate-y-[-50%]`}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          <X size={22} />
        </button>

        {/* Header */}
        <div className="flex items-center gap-2 mb-6 mt-8">
          <Mail className="mx-auto text-blue-400" />
          <h2 className="mr-auto text-xl font-bold text-center">
            Subscribe to Updates
            <br />
            (Personal Email)
          </h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            type="email"
            name="fields[email]"
            placeholder="Enter your email"
            required
            className="border border-gray-600 bg-[#2c2c2c] px-3 py-2 rounded text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="bg-blue-600 text-white px-4 py-2 rounded-md font-medium
              hover:bg-blue-500 disabled:opacity-50 transition-all duration-150 ease-[cubic-bezier(0.22,0.61,0.36,1)]"
          >
            {status === "loading" ? "Subscribing..." : "Subscribe"}
          </button>
        </form>

        {/* Status messages */}
        {status === "success" && (
          <p className="text-green-400 text-sm mt-3">
            🎉 You’re in! We just sent you the latest updates.
          </p>
        )}

        {/* Duplicate email message */}
        {status === "duplicate" && (
          <p className="text-yellow-400 text-sm mt-3">
            ⚠️ This email is already subscribed.
          </p>
        )}
        {status === "error" && (
          <p className="text-red-400 text-sm mt-3">
            ❌ Something went wrong. Please try again.
          </p>
        )}
      </div>
    </div>



  );
}
